import axios from 'axios';
import AppConfig from "../../../../AppConfig";

let URL = AppConfig.HOST_API()+'pojazdy/';

export default {

    getPojazdy() {
        return axios({
            method: 'get',
            url: URL + '?page=0&size=9999',
        });
    },

    getPojazdyDostepne(idKu) {
        return axios({
            method: 'get',
            url: URL + 'aktywne/'+idKu,
        });
    },

    addPojazd(data) {
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    editPojazd(id, data) {
        return axios(
            {
                url: URL + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    deletePojazd(id) {
        return axios({
                url: URL + id,
                method: 'delete',
            }
        )
    },

    getSerwis(idPo) {
        return axios({
            method: 'get',
            url: AppConfig.HOST_API() + `pojazdySerwis/pojazd/${idPo}`,
        });
    },

    addSerwis(idPo, opis) {
        return axios({
            method: 'post',
            url: AppConfig.HOST_API() + `pojazdySerwis`,
            data: {
                idPo: idPo,
                opis: opis
            }
        });
    },

}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/zasobyConfig/pojazdy/PojazdyService.js